"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAccordion;
Object.defineProperty(exports, "UseAccordion", {
  enumerable: true,
  get: function get() {
    return _types.UseAccordion;
  }
});

var _difference = _interopRequireDefault(require("lodash/difference"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _without = _interopRequireDefault(require("lodash/without"));

var _react = require("react");

var _utils = require("../utils");

var _constants = require("./constants");

var _reducer = _interopRequireDefault(require("./reducer"));

var _types = require("./types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function disableControl(items, expandedIds, controlType) {
  var _parseItemsByStatus = (0, _utils.parseItemsByStatus)(items),
      disabledIds = _parseItemsByStatus.disabledIds,
      enabledIds = _parseItemsByStatus.enabledIds;

  if (enabledIds.length <= 1) {
    return true;
  }

  var hasExpandedAllEnabledItems = (0, _isEmpty.default)((0, _difference.default)(enabledIds, expandedIds));
  var hasExpandedAnyDisabledItems = !(0, _isEmpty.default)(_without.default.apply(void 0, [expandedIds].concat(_toConsumableArray(enabledIds))));
  var hasExpandedAnyEnabledItems = !(0, _isEmpty.default)(_without.default.apply(void 0, [expandedIds].concat(_toConsumableArray(disabledIds))));
  var hasExpandedAnyItems = !(0, _isEmpty.default)(expandedIds);

  if (controlType === 'collapse') {
    return !hasExpandedAnyItems || hasExpandedAnyDisabledItems && !hasExpandedAnyEnabledItems;
  } // controlType === 'expand' is assumed based on type def.


  return hasExpandedAllEnabledItems;
}

function useAccordion(_ref) {
  var _ref$defaultExpanded = _ref.defaultExpanded,
      defaultExpanded = _ref$defaultExpanded === void 0 ? [] : _ref$defaultExpanded,
      expanded = _ref.expanded,
      items = _ref.items,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? _noop.default : _ref$onChange;

  var _parseItemsByStatus2 = (0, _utils.parseItemsByStatus)(items),
      enabledIds = _parseItemsByStatus2.enabledIds;

  var _useReducer = (0, _react.useReducer)(function (oldState, action) {
    var newState = (0, _reducer.default)(oldState, action);

    if (oldState.expandedIds !== newState.expandedIds && // the expanded ids have changed
    action.type !== _constants.UPDATE_EXPANDED_IDS // the updated was not because of a new `expanded` value
    ) {
      onChange(_toConsumableArray(newState.expandedIds)); // spread to prevent mutations on the array
    }

    if (Array.isArray(expanded)) {
      // The component is being controlled. The value of the `expanded` prop
      // should _always_ override the internal state.
      return _objectSpread({}, newState, {
        expandedIds: expanded
      });
    }

    return newState;
  }, {
    enabledIds: enabledIds,
    expandedIds: defaultExpanded
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1]; // This effect runs if there is a change to the items that are enabled. It updates the
  // enabledIds in the reducer state.


  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)((0, _difference.default)(enabledIds, state.enabledIds))) {
      dispatch({
        type: _constants.UPDATE_ENABLED_IDS,
        enabledIds: enabledIds
      });
    }
  }, [enabledIds]); // eslint-disable-line react-hooks/exhaustive-deps
  // This effect runs if there is a change to the expanded prop. Supplying an expanded prop
  // indicates that this component is controlled. The value of `expanded` overrides the internal
  // state.

  (0, _react.useEffect)(function () {
    if (Array.isArray(expanded)) {
      dispatch({
        type: _constants.UPDATE_EXPANDED_IDS,
        expandedIds: expanded
      });
    }
  }, [expanded]);
  var collapseAll = disableControl(items, state.expandedIds, 'collapse') ? undefined : function () {
    return dispatch({
      type: _constants.COLLAPSE_ALL
    });
  };
  var expandAll = disableControl(items, state.expandedIds, 'expand') ? undefined : function () {
    return dispatch({
      type: _constants.EXPAND_ALL
    });
  };

  var isItemExpanded = function isItemExpanded(_ref2) {
    var disabled = _ref2.disabled,
        id = _ref2.id;
    return !disabled && state.expandedIds.includes(id);
  };

  var toggle = function toggle(id) {
    return dispatch({
      type: _constants.TOGGLE,
      id: id
    });
  };

  return {
    collapseAll: collapseAll,
    expandAll: expandAll,
    isItemExpanded: isItemExpanded,
    toggle: toggle
  };
}